import {simpleHash} from 'plugins/utils';

/**
 * Generate a unique heading ID
 * Format: heading-{shortHash}
 */
export function generateHeadingId(): string {
  return `heading-${simpleHash()}`;
}
